
export default class Graphics {
	constructor(canvas) {
		this.canvas = canvas;
		this.context = canvas.getContext("2d");

		this.rect = null;
		this.scale = 1;

		this.context.lineWidth = 3;
		// round, bevel, miter
		this.context.lineCap = "round";
		this.context.lineJoin = "round";

		this.onResize();
	}

	update() {
		this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);

		// Circle
		// this.strokeCircle(this.width/2, this.height/2, this.height/2*0.9);

		// this.roundRect(400, 200, 200, 100, 20).stroke();

		// this.context.setLineDash([10, 10]);
		// this.context.lineDashOffset = -40*time;

		// https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Applying_styles_and_colors
		// this.line(500, 100, 700, 400).stroke();
	}

	// strokeLine(x1, y1, x2, y2) {
		// this.line(x1, y1, x2, y2).stroke();
	// }

	drawLine(x1, y1, x2, y2) {
		this.context.beginPath();
		this.context.moveTo(x1, y1);
		this.context.lineTo(x2, y2);
		this.context.stroke();
	}

	drawArrow(x1, y1, x2, y2, arrow, includeHead, includeBody=true) {
		// let cx1 = x1;
		// let cy1 = y1+100;
		// let cx2 = x2;
		// let cy2 = y2-100;
		// let ah = 20;

		// // Line
		this.context.beginPath();
		this.context.moveTo(x1, y1);
		// this.context.bezierCurveTo(
		// 	cx1, cy1,
		// 	cx2, cy2,
		// 	x2, y2-ah);
		// return this.context;

		let mx = (x1 + x2) / 2;
		let my = (y1 + y2) / 2;
		let dx = Math.sign(x2 - x1);
		let dy = Math.sign(y2 - y1);
		let k = Math.min(30, Math.abs(x2 - x1)/2, Math.abs(y2 - y1)/2);
		let s = k/4;

		if (Math.abs(arrow.from_edge.x) >= 1 && Math.abs(arrow.to_edge.x) >= 1 && y1 != y2) {
			this.context.lineTo(mx-k*dx, y1);
			this.context.bezierCurveTo(
				mx-s*dx, y1,
				mx, y1+s*dy,
				mx, y1+k*dy);
			this.context.lineTo(mx, y2-k*dy);
			this.context.bezierCurveTo(
				mx, y2-s*dy,
				mx+s*dx, y2,
				mx+k*dx, y2);
		}
		else if (Math.abs(arrow.from_edge.y) >= 1 && Math.abs(arrow.to_edge.y) >= 1 && x1 != x2) {
			this.context.lineTo(x1, my-k*dy);
			this.context.bezierCurveTo(
				x1, my-s*dy,
				x1+s*dx, my,
				x1+k*dx, my);
			this.context.lineTo(x2-k*dx, my);
			this.context.bezierCurveTo(
				x2-s*dx, my,
				x2, my+s*dy,
				x2, my+k*dy);
		}
		else if (Math.abs(arrow.from_edge.y) == 1) {
			this.context.lineTo(
				x1, y2-k*dy);
			this.context.bezierCurveTo(
				x1, y2-s*dy,
				x1+s*dx, y2,
				x1+k*dx, y2);
		}
		else if (Math.abs(arrow.from_edge.x) == 1) {
			this.context.lineTo(
				x2-k*dx, y1);
			this.context.bezierCurveTo(
				x2-s*dx, y1,
				x2, y1+s*dy,
				x2, y1+k*dy);
		}

		if (includeBody) {
			this.context.lineTo(x2, y2);
			this.context.stroke();
		}

		// Arrow head
		if (includeHead) {
			if (Math.abs(arrow.to_edge.y) >= 1) {
				this.drawArrowhead(x2, y2, 0, Math.sign(y2-y1));
			}
			else if (Math.abs(arrow.to_edge.x) >= 1) {
				this.drawArrowhead(x2, y2, Math.sign(x2-x1), 0);
			}
		}
	}

	drawArrowhead(x, y, dx, dy, size=10) {
		this.setStroke(this.context.lineWidth);

		if (dx != 0 || dy != 0) {
			let a = Math.atan2(dy, dx);

			this.context.beginPath();
			this.context.moveTo(
				x + size * Math.cos(a + Math.PI*5/4),
				y + size * Math.sin(a + Math.PI*5/4)
			);
			this.context.lineTo(x, y);
			this.context.lineTo(
				x + size * Math.cos(a - Math.PI*5/4),
				y + size * Math.sin(a - Math.PI*5/4)
			);
		}

		this.context.stroke();
	}

	/* Circle */

	strokeCircle(x, y, r) {
		this.circle(x, y, r).stroke();
	}

	fillCircle(x, y, r) {
		this.circle(x, y, r).fill();
	}

	circle(x, y, r) {
		this.context.beginPath();
		this.context.arc(x, y, r, 0, 2 * Math.PI);
		return this.context;
	}


	/* Round rectangle */

	// strokeRoundRect(x, y, w, h, r) {}

	// fillRoundRect(x, y, w, h, r) {}

	drawRoundRect(x, y, w, h, r) {
		if (w < 2 * r) r = w / 2;
		if (h < 2 * r) r = h / 2;
		this.context.beginPath();
		this.context.moveTo(x+r, y);
		this.context.arcTo(x+w, y,   x+w, y+h, r);
		this.context.arcTo(x+w, y+h, x,   y+h, r);
		this.context.arcTo(x,   y+h, x,   y,   r);
		this.context.arcTo(x,   y,   x+w, y,   r);
		this.context.closePath();
		this.context.stroke();
	}


	setStroke(width=3, dash=[], offset=0) {
		this.context.lineWidth = width;
		this.context.setLineDash(dash);
		this.context.lineDashOffset = -offset;
	}


	onResize() {
		this.rect = this.canvas.getBoundingClientRect();
	}

	getCanvasRect() {
		return [
			Math.round(this.rect.x),
			Math.round(this.rect.y),
			Math.round(this.rect.width),
			Math.round(this.rect.height)
		];
	}

	setMouse(pos, mx, my) {
		return {
			x: (mx - this.rect.left) * (this.width / this.rect.width),
			y: (my - this.rect.top) * (this.height / this.rect.height),
		};
	}

	get width() {
		return this.canvas.width;
	}

	get height() {
		return this.canvas.height;
	}
}
